import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'
import classnames from 'classnames'
import ReactDOM from 'react-dom'
import ReactSwipe from 'react-swipe'

// import styles from './styles.css'
import Icon from '_components/icon'

class ReactSwipeChild extends PureComponent {
  static propTypes = {}

  render() {
    const { children } = this.props

    return (
      <div
        style={{
          flex: 1,
          padding: 20,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {children}
      </div>
    )
  }
}

export default ReactSwipeChild



// WEBPACK FOOTER //
// ./src/components/categoryTabs/categoryTabBodySwipe/reactSwipeChild/index.js